// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasklists-container {
  padding: 20px;
  color: white;
}

.tasklists-container h1 {
  margin-bottom: 30px;
  text-align: center;
}

.tasklists-grid {
  display: flex;
  flex-wrap: wrap;
  gap:25px;
  max-width: 800px;
  margin: 0 auto;
  justify-content: center;
  padding-top: 3em;
}

.tasklist-tile {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 25px;
  text-align: center;
  text-decoration: none;
  color: white;
  transition: transform 0.2s, background-color 0.2s;
  cursor: pointer;
  width: 12em;

}

.tasklist-tile:hover {
  transform: translateY(-5px);
  background-color: rgba(255, 255, 255, 0.15);
}

.tile-icon {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.tasklist-tile h2 {
  margin: 0;
  font-size: 1.2rem;
}

.template-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.use-btn {
  background-color: #4CAF50;
  color: white;
}

.use-btn:hover {
  background-color: #45a049;
}

.use-btn:active {
  transform: scale(0.98);
}

.use-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.edit-button {
  background-color: #4a90e2;
  color: white;
}

.delete-button {
  background-color: #e25c5c;
  color: white;
}

.edit-button:hover {
  background-color: #357abd;
}

.delete-button:hover {
  background-color: #c74545;
}

.template-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
} `, "",{"version":3,"sources":["webpack://./src/components/forms/Tasklists.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,iDAAiD;EACjD,eAAe;EACf,WAAW;;AAEb;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".tasklists-container {\n  padding: 20px;\n  color: white;\n}\n\n.tasklists-container h1 {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.tasklists-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap:25px;\n  max-width: 800px;\n  margin: 0 auto;\n  justify-content: center;\n  padding-top: 3em;\n}\n\n.tasklist-tile {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 25px;\n  text-align: center;\n  text-decoration: none;\n  color: white;\n  transition: transform 0.2s, background-color 0.2s;\n  cursor: pointer;\n  width: 12em;\n\n}\n\n.tasklist-tile:hover {\n  transform: translateY(-5px);\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.tile-icon {\n  font-size: 2.5rem;\n  margin-bottom: 10px;\n}\n\n.tasklist-tile h2 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.template-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.use-btn {\n  background-color: #4CAF50;\n  color: white;\n}\n\n.use-btn:hover {\n  background-color: #45a049;\n}\n\n.use-btn:active {\n  transform: scale(0.98);\n}\n\n.use-btn:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.edit-button {\n  background-color: #4a90e2;\n  color: white;\n}\n\n.delete-button {\n  background-color: #e25c5c;\n  color: white;\n}\n\n.edit-button:hover {\n  background-color: #357abd;\n}\n\n.delete-button:hover {\n  background-color: #c74545;\n}\n\n.template-actions button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
